import { useQuery } from '@tanstack/vue-query'
import { getApi } from "./api";

export default (accountId: number | null, queryParams?: Record<string, any>) => useQuery({
    queryKey: ['account-ai-reports', accountId, queryParams],
    queryFn: () => {
        if (!accountId) {
            return Promise.resolve(null)
        }
        
        const { api, baseURL } = getApi();
        return api.get(`api/v2/accounts/${accountId}/ai-reports`, {
          baseURL,
          useOriginalToken: true,
          params: queryParams
        }).then(res => res.data.data);
    },
    enabled: !!accountId,
})
